import { useContext } from 'react'
import { ChatbotDialogContext } from '../contexts/ChatbotDialogProvider'

export const useChatbotDialog = () => {
	const context = useContext(ChatbotDialogContext)
	if (context === undefined) {
		throw new Error(
			'useChatbotDialog must be used within a ChatbotDialogProvider'
		)
	}
	return context
}
